import IgManageShell from "@/components/IgManageShell";
import InstagramTemplates from "@/components/InstagramTemplates";

export default function InstagramTemplateManager() {
  return (
    <IgManageShell need="templates" title="Instagram Template Manager">
      <div data-testid="ig-template-manager-page">
        <InstagramTemplates />
      </div>
    </IgManageShell>
  );
}
